// After someone signs in with Clerk (Apple, Google or a phone code), trade the Clerk session
// for the normal InstaPass session (POST /api/user/clerk), exactly like the app does.
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useAuth } from "@clerk/react";
import toast from "react-hot-toast";
import { ApiURL } from "../setting/GlobleVariable";
import { LOGIN_USER_SUCCESS } from "../redux/constant/User";
import { nextPath } from "../redux/actions/User";

export default function ClerkBridge() {
  const { isSignedIn, getToken } = useAuth();
  const dispatch = useDispatch();
  const busy = useRef(false);

  useEffect(() => {
    if (!isSignedIn || busy.current || localStorage.getItem("instapass_user_token")) return;
    busy.current = true;
    (async () => {
      try {
        const clerkToken = await getToken();
        const res = await fetch(`${ApiURL}/user/clerk`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${clerkToken}` },
          body: JSON.stringify({ source: "web" }),
        });
        const data = await res.json();
        if (!res.ok || !data.Token) throw new Error(data.message || "Sign-in didn't finish.");
        localStorage.setItem("instapass_user_token", data.Token);
        dispatch({ type: LOGIN_USER_SUCCESS, payload: { ...data.user, capabilities: data.capabilities } });
        toast.success(data.message || "Signed in");
        if (window.location.pathname.startsWith("/login")) window.location.assign(nextPath());
      } catch (e) {
        toast.error(e.message || "Sign-in didn't finish.");
        busy.current = false;
      }
    })();
  }, [isSignedIn, getToken, dispatch]);

  return null;
}
